import { InjectionToken } from '@angular/core';
import type { Auth as AuthInstance } from 'firebase/auth';

export const Auth = new InjectionToken<AuthInstance>('marmon.firebase.auth');
